import { AnalyticsOrderFlowTypes, StudentInstructorToggleGroup } from '../utils/analytics-util';
import { OrderType } from './order-types';
import { StoreState } from "../../store/store.interface";
import { WishList } from "../../features/wish-list/interfaces/wish-list-items.interface";

export interface CartAnalyticsOverrides {
  orderType: OrderType | string;
  orderFlow?: AnalyticsOrderFlowTypes;
}

export interface ProductAnalyticsData {
  isbn?: string;
  isbn13?: string;
  title?: string;
  businessUnit?: string;
  copyrightYear?: string;
  nextEdition?: string;
  gradeLevel?: string;
  requestedIsbn?: string;
  specificMarket?: string;
  isEdoms?: boolean;
  isHePdp?: boolean;
  pdpType?: string;
  isProfPdp?: boolean;
  programSourceId?: string;
  isEvergreenPDP?: boolean;
  editionOrRelease?: string;
  pdpViewType?: string;
  purchaseOptions?: PurchaseOptionAnalyticsData[];
  contributors?: string[];
  // Needs to be verified as these fields are not present on AEM
  productType?: any;
  release?: any;
  titleType?: string | null;
  division?: string | null;
}

export interface PurchaseOptionAnalyticsData {
  isbn?: string;
  isbn13?: string;
  title?: string;
  cardDescription?: string;
  listPrice?: number;
  netPrice?: number;
  duration?: number;
  durationPeriod?: string;
  isEvergreenProduct?: boolean;
}

export interface AddToCartAnalyticsData {
  product: ProductAnalyticsData;
  purchaseOption?: PurchaseOptionAnalyticsData;
  state: StoreState;
  isbn?: string;
  productTitle?: string;
  businessUnit?: string;
  copyrightYear?: string;
  instructorOnly?: boolean;
  isbn13?: string;
  netPrice?: number;
  listPrice?: number;
  description?: string;
  gradeLevel?: string;
  quantity?: number;
  store?: string;
  contributors?: string;
  edition?: number;
  editionOrRelease?: string;
  pdpType?: string;
  dataset?;
  isWishListProduct?: boolean;
  wishList?: WishList;
  addToCartPageType?: string;
  showQuantity?: boolean;
  showTotal?: boolean;
  showPrice?: boolean;
  externalUrl?: string;
  instantCheckout?: boolean;
  showRemoveLink?: boolean;
  format?: string;
  programSourceId?: string;
  hePDPViewType?: StudentInstructorToggleGroup;
  offerType?: string;
  offerPricingId?: string;
  productType?: string;
  isEdoms?: boolean;
  catalog?: string;
  isVirtual?: boolean;
  poType?: string;
  durationType?: string;
  duration?: number;
  durationPeriod?: string;
  isEvergreenProduct?: boolean;
  removeFromCartPreview?: boolean;
  coverImage?: string;
  orderFlow?: AnalyticsOrderFlowTypes;
  isCreateProduct?: boolean;
  formatDesc?: string;
  formatTypeDesc?: string;
}

export enum SearchTermAnalyticsConstants {
  SEARCH_PAGE_LOCAL_STORAGE_OBJECT='SEARCH_PAGE_LOCAL_STORAGE_OBJECT',
  PDP_PAGE_LOCAL_STORAGE_OBJECT='PDP_PAGE_LOCAL_STORAGE_OBJECT',
  CART_PAGE_LOCAL_STORAGE_OBJECT='CART_PAGE_LOCAL_STORAGE_OBJECT',
  RESET_SEARCH_LOCAL_STORAGE='RESET_SEARCH_LOCAL_STORAGE',
  RELATED_PRODUCTS_MAPPER='RELATED_PRODUCTS_MAPPER',
}

export const productDiscoveryQPKey = 'pd';
export const productDiscoveryQPValue = 'search';

export enum CoverImageAnalyticsConstants {
  SHOWN = 'shown',
  NOT_SHOWN = 'not shown',
}

export const INSTRUCTOR_PRODUCTS_REMOVED_KEY = 'MHECOMM_INSTRUCTOR_PRODUCTS_REMOVED';
